import { render, staticRenderFns } from "./Percepcion.vue?vue&type=template&id=7e1d924e&"
import script from "./Percepcion.vue?vue&type=script&lang=js&"
export * from "./Percepcion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports